import { getLimitSeat, getReservation } from '@/apis/requests/reservation';
import { getUser } from '@/apis/requests/login';
import { GroupScheduleForm } from '@/components';
import { useRouter } from 'next/router';
import ReservationDTO from '@/apis/DTOs/ReservationDTO';
import { getCookie, routingServerAndClientSide } from '@/utils';
import { getHolidays } from '@/apis/requests/holiday';
import { withAuth } from '@/HOC';
import { SubPageLayout } from '@/layouts';
import { setAuthorizationHeader } from '@/apis/server';

const GroupScheduleFormPage = (props) => {
  const router = useRouter();
  const { id } = router.query;
  const { limitSeatData, reservationData, holidaysData } = props;
  const isUpdateForm = !!id;

  return (
    <GroupScheduleForm
      isUpdateForm={isUpdateForm}
      minSeat={limitSeatData?.groupMinSeat}
      formData={isUpdateForm ? new ReservationDTO(reservationData) : undefined}
      holidays={holidaysData}
    />
  );
};

GroupScheduleFormPage.getInitialProps = async (context, payload) => {
  const { res, query } = context;

  try {
    const { id } = query;
    const { auth } = payload;

    const responseLimitSeat = await getLimitSeat();
    const { data: limitSeatData } = responseLimitSeat;

    const responseHolidays = await getHolidays();
    const { data: holidaysData } = responseHolidays;

    if (!id) {
      return {
        limitSeatData: limitSeatData.data,
        holidaysData: holidaysData.data,
      };
    }

    if (auth.isNotLoggedIn) {
      routingServerAndClientSide({ res, path: '/login' });
      return {};
    }

    const responseReservation = await getReservation({ id });
    const { data: reservationData } = responseReservation;

    if (reservationData.code !== 0 || reservationData.data.reservationType !== 'GROUP' || reservationData.data.reservationStatus !== 'REQUEST') {
      routingServerAndClientSide({ res, path: '/notfound' });
      return {};
    }
    return {
      limitSeatData: limitSeatData.data,
      reservationData: reservationData.data,
      holidaysData: holidaysData.data,
    };
  } catch (error) {
    const { res } = context;
    return routingServerAndClientSide({ res, path: '/notfound' });
  }
};

GroupScheduleFormPage.getLayout = function getLayout(page) {
  return <SubPageLayout>{page}</SubPageLayout>;
};

export default withAuth(GroupScheduleFormPage);
